"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.status.pending': 'Oczekująca',
    'payment.status.success': 'Sukces',
    'payment.status.rejected': 'Odrzucona',
    'payment.status.error': 'Błąd',
    'payment.status.unknown': 'Nieznany',
};
